import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import * as THREE from 'three'
const baseURL = 'https://resources.roche-bobois.com'
const footers = [
  'Footer_rect_200',
  'Footer_rect_240',
  'Footer_rect_280',
  'Footer_round_160',
  'Footer_round_190'
]
const trays = [
  'Tray_rect_200',
  'Tray_rect_240',
  'Tray_rect_280',
  'Tray_round_160',
  'Tray_round_190'
]
const extension = '.obj'

export const LoadMeshes = async (scene, trayMaterial, footerMaterial) => {
  for (let i = 0; i < footers.length; i++) {
    await LoadMesh(footers[i], scene, footerMaterial)
  }
  for (let i = 0; i < trays.length; i++) {
    await LoadMesh(trays[i], scene, trayMaterial)
  }
}

export const LoadCamMesh = async () => {
  return await LoadMeshCache('CameraObj')
}

export const DisplayTray = (scene, name) => {
  trays.forEach(object => {
    if (object === name) {
      const obj = scene.getObjectByName(object)
      if (obj) {
        obj.visible = true
      }
    } else {
      const obj = scene.getObjectByName(object)
      if (obj) {
        obj.visible = false
      }
    }
  })
}

export const DisplayFooter = (scene, name) => {
  footers.forEach(object => {
    if (object === name) {
      const obj = scene.getObjectByName(object)
      if (obj) {
        obj.visible = true
      }
    } else {
      const obj = scene.getObjectByName(object)
      if (obj) {
        obj.visible = false
      }
    }
  })
}

const LoadMesh = async function (objectToLoad, scene, material) {
  const loader = new OBJLoader()
  const obj = await loader.loadAsync(`${baseURL}/corail/assets/meshes/` + objectToLoad + extension)
  obj.traverse(function (child) {
    if (child instanceof THREE.Mesh) {
      child.material = material
      child.scale.set(
        0.01,
        0.01,
        0.01
      )
      child.rotation.set(THREE.Math.degToRad(90), 0, THREE.Math.degToRad(90))
      obj.name = objectToLoad
      scene.add(obj)
      obj.visible = false
    }
  })
}

const LoadMeshCache = async function (objectToLoad) {
  const loader = new OBJLoader()
  const obj = await loader.loadAsync(`${baseURL}/corail/assets/meshes/` + objectToLoad + extension)
  return obj
}
